import mixGenerarPdf from '@/helpers/mixGenerarPdf';
import mixFormatoEstructura from '@/helpers/mixFormatoEstructura';

export default {
  name: 'MainReporteEstimacionesRelacionConceptos',
  mixins: [mixGenerarPdf, mixFormatoEstructura],
  data() {
    return {};
  },
  methods: {
    sumaImporteContratado(estimado) {
      const importes = estimado.map((est) => ({
        importe: est.concepto.importe,
      }));
      return this.$ObjSumar(importes, 'importe');
    },
    formatoObjeto(objeto) {
      return this.formatoEstructura(objeto);
    },
    async generarPdfRelacionConceptos() {
      this.$emit('generando');
      const encabezadoReferencia = this
        .mixGeneraEncabezadosPdf(`${this.estimacion.fechaPresentacion} 00:00:0`, this.firmas);

      let contrato = {
        numero: this.contrato.numero,
        objeto: this.contrato.meta.slice(0, 950),
        contratista: this.contrato.contratista,
        fecha: this.contrato.fecha,
        fechaInicio: this.contrato.fechaInicio,
        fechaTermino: this.contrato.fechaTermino,
        importe: this.contrato.esObraFinanciada
          ? (this.contrato.importeCostoDirecto + this.contrato.modificado.importeCostoDirecto)
          : this.contrato.importe,
      };
      let estimacion = {
        numero: this.estimacion.numero,
        fechaDel: this.estimacion.fechaDel,
        fechaAl: this.estimacion.fechaAl,
        fechaPresentacion: this.estimacion.fechaPresentacion,
        fechaAutorizacion: this.estimacion.fechaAutorizacion,

      };
      const tituloTotales = this.contrato.esObraFinanciada ? 'IMPORTE COSTO DIRECTO' : 'IMPORTE ESTIMADO';
      let totales = {
        tituloTotales,
        sumaTotalContratado: this.sumaTotalContratado.importe,
        sumaTotalEstimadoAnterior: this.sumaTotalEstimadoAnteriror.importe,
        sumaTotalEstimadoActual: this.sumaTotalEstimadoActual.importe,
        sumaTotalAcumulado: this.sumaTotalEstimadoAnteriror.importe
                            + this.sumaTotalEstimadoActual.importe,
      };
      let partidas = this.getPartidas;
      const partidasSubtotal = partidas.map((partida) => {
        const subtotalImporteContratado = this.sumaImporteContratado(
          partida.conceptosEstimados,
        ) || 0;
        const subtotalImporteEstimadoAnterior = this.$ObjSumar(partida.conceptosEstimados, 'importeEstimadoAnterior') || 0;
        const subtotalImporte = this.$ObjSumar(partida.conceptosEstimados, 'importe') || 0;
        const subtotalImporteAcumulado = this.$ObjSumar(partida.conceptosEstimados, 'importeEstimadoAnterior') || 0
                    + this.$ObjSumar(partida.conceptosEstimados, 'importe') || 0;
        return {
          partida,
          subtotalImporteContratado,
          subtotalImporteEstimadoAnterior,
          subtotalImporte,
          subtotalImporteAcumulado,
        };
      });

      partidas = this.formatoObjeto(partidasSubtotal);
      estimacion = this.formatoObjeto(estimacion);
      contrato = this.formatoObjeto(contrato);
      const supervisor = this.getSupervisorEnRelacionConceptos || '';
      const supervisionExterna = this.getContratoSupervisionExternaEnRelacionConceptos
        ?.contratoRelacionado
        ?.contratista?.nombreRazonSocial || '';
      const firmasFuncionarios = encabezadoReferencia.firmas || [];
      const fechaActual = this.formatoFechaActual();
      totales = this.formatoObjeto(totales);

      const nombreTemplate = 'templateRelacionConceptos';

      await this.mixGenerarPdf({
        configuracion: {
          path: 'wepp/wep',
          PUPPETEER_CONFIGURACION: {
            landscape: true,
            format: 'A3',
            displayHeaderFooter: false,
            margin: { top: '0px', bottom: '0px' },
            /*
            footerTemplate: `
            <div class="footer-template" style="font-size: 8px;
            color:#3b3b66; margin: 0px auto;>
            <span class="clas"></span>
            <span class="pageNumber" style="font-weight:bold;"></span> /
            <span class="totalPages" style="font-weight:bold;"></span>
            <span class="date"></span>
            </div>`,
            */
          },
          nombreTemplate,
        },
        data: {
          contrato,
          estimacion,
          partidas,
          supervisor,
          supervisionExterna,
          firmas: firmasFuncionarios,
          fechaActual,
          totales,
          footer: '',
          encabezadoReferencia,
        },
      }, `${this.contrato.numero}_RelacionConceptos_Estimacion_${this.estimacion.numero}`);
      this.$emit('terminando');
    },
  },
  computed: {
    getCatalogoPartidas() {
      // if (!this.contratoCatalogoConceptosPartidas) return [];
      if (!this.conceptos) return [];
      // return this.contratoCatalogoConceptosPartidas.map((partida) => ({
      return this.conceptos.map((partida) => ({
        id: partida.id,
        idPadre: partida.idPadre,
        clave: partida.clave.slice(0, 15),
        concepto: partida.concepto,
        orden: partida.orden,
        padre: null,
        tipo: partida.tipo,
        conceptosEstimados: [],
      }));
    },
    getPartidas() {
      // if (!this.contratoCatalogoConceptosPartidas) return [];
      if (!this.conceptos) return [];

      // Formato de conceptos
      const partidas = this.estimacion.conceptos
        .filter(({ cantidad }) => cantidad !== 0)
        .map(({ concepto: { padre }, concepto }) => {
          let partida = null;
          if (padre.padre && (padre.padre.tipo === 0 || padre.padre.tipo === 1)) {
            partida = padre.padre;
          }
          return {
            id: padre.id,
            idPadre: padre.idPadre,
            clave: padre.clave.slice(0, 15),
            concepto: padre.concepto,
            orden: concepto.orden,
            padre: partida,
            tipo: padre.tipo,
            conceptosEstimados: [],
          };
        });

      // Remover conceptos repetidos
      const partidasUnicas = [...new Map(partidas.map((v) => [v.id, v])).values()];

      const partidasEstimadas = partidasUnicas.map((partida) => {
        const conceptos = this.estimacion.conceptos
          .filter(({ cantidad }) => cantidad !== 0)
          .filter(({ concepto: { padre } }) => padre.id === partida.id)
          .map((concepto) => {
            const { estimado } = concepto.concepto;
            const estimadoAnterior = estimado
              .map((con) => ({
                numero: con.estimacion.numero,
                cantidad: con.cantidad,
                importe: con.importe,
              }))
              .filter(({ numero }) => numero < this.estimacion.numero);

            return {
              ...concepto,
              cantidadEstimadaAnterior: this.$ObjSumar(estimadoAnterior, 'cantidad') || 0,
              importeEstimadoAnterior: this.$ObjSumar(estimadoAnterior, 'importe') || 0,
              cantidadEstimadaAcumulada: ((this.$ObjSumar(estimadoAnterior, 'cantidad') || 0) + (concepto.cantidad || 0)),
              importeEstimadoAcumulado: (this.$ObjSumar(estimadoAnterior, 'importe') || 0) + (concepto.importe || 0),
            };
          })
          .sort((a, b) => a.concepto.orden - b.concepto.orden);

        return {
          ...partida,
          conceptosEstimados: conceptos,
        };
      });
      // .sort((a, b) => a.orden - b.orden)
      const partidasNivelCinco = this.getCatalogoPartidas
        .filter(({ id }) => partidasEstimadas.map(({ idPadre }) => idPadre).includes(id))
        .map((partida) => {
          const conceptosEstimadosHijos = partidasEstimadas
            .filter(({ idPadre }) => idPadre === partida.id)
            .map(({ conceptosEstimados }) => conceptosEstimados)
            .flat();

          return {
            ...partida,
            tipo: 11,
            cantidadEstimadaAnterior: this.$ObjSumar(conceptosEstimadosHijos, 'cantidad'),
            importeEstimadoAnterior: this.$ObjSumar(conceptosEstimadosHijos, 'importe') || 0,
            cantidadEstimadaAcumulada: this.$ObjSumar(conceptosEstimadosHijos, 'cantidad') || 0,
            importeEstimadoAcumulado: this.$ObjSumar(conceptosEstimadosHijos, 'importe'),
            conceptosEstimados: [],
          };
        });

      const partidasNivelCuatro = this.getCatalogoPartidas
        .filter(({ id }) => partidasNivelCinco.map(({ idPadre }) => idPadre).includes(id))
        .map((partida) => {
          const conceptosEstimadosHijos = partidasNivelCinco
            .filter(({ idPadre }) => idPadre === partida.id);

          return {
            ...partida,
            tipo: 11,
            cantidadEstimadaAnterior: this.$ObjSumar(conceptosEstimadosHijos, 'cantidadEstimadaAnterior'),
            importeEstimadoAnterior: this.$ObjSumar(conceptosEstimadosHijos, 'importeEstimadoAnterior') || 0,
            cantidadEstimadaAcumulada: this.$ObjSumar(conceptosEstimadosHijos, 'cantidadEstimadaAcumulada') || 0,
            importeEstimadoAcumulado: this.$ObjSumar(conceptosEstimadosHijos, 'importeEstimadoAcumulado'),
            conceptosEstimados: [],
          };
        });

      const partidasNivelTres = this.getCatalogoPartidas
        .filter(({ id }) => partidasNivelCuatro.map(({ idPadre }) => idPadre).includes(id))
        .map((partida) => {
          const conceptosEstimadosHijos = partidasNivelCuatro
            .filter(({ idPadre }) => idPadre === partida.id);

          return {
            ...partida,
            tipo: 11,
            cantidadEstimadaAnterior: this.$ObjSumar(conceptosEstimadosHijos, 'cantidadEstimadaAnterior'),
            importeEstimadoAnterior: this.$ObjSumar(conceptosEstimadosHijos, 'importeEstimadoAnterior') || 0,
            cantidadEstimadaAcumulada: this.$ObjSumar(conceptosEstimadosHijos, 'cantidadEstimadaAcumulada') || 0,
            importeEstimadoAcumulado: this.$ObjSumar(conceptosEstimadosHijos, 'importeEstimadoAcumulado'),
            conceptosEstimados: [],
          };
        });

      const partidasNivelDos = this.getCatalogoPartidas
        .filter(({ id }) => partidasNivelTres.map(({ idPadre }) => idPadre).includes(id))
        .map((partida) => {
          const conceptosEstimadosHijos = partidasNivelTres
            .filter(({ idPadre }) => idPadre === partida.id);

          return {
            ...partida,
            tipo: 11,
            cantidadEstimadaAnterior: this.$ObjSumar(conceptosEstimadosHijos, 'cantidadEstimadaAnterior'),
            importeEstimadoAnterior: this.$ObjSumar(conceptosEstimadosHijos, 'importeEstimadoAnterior') || 0,
            cantidadEstimadaAcumulada: this.$ObjSumar(conceptosEstimadosHijos, 'cantidadEstimadaAcumulada') || 0,
            importeEstimadoAcumulado: this.$ObjSumar(conceptosEstimadosHijos, 'importeEstimadoAcumulado'),
            conceptosEstimados: [],
          };
        });

      const partidasNivelUno = this.getCatalogoPartidas
        .filter(({ id }) => partidasNivelDos.map(({ idPadre }) => idPadre).includes(id))
        .map((partida) => {
          const conceptosEstimadosHijos = partidasNivelDos
            .filter(({ idPadre }) => idPadre === partida.id);

          return {
            ...partida,
            tipo: 11,
            cantidadEstimadaAnterior: this.$ObjSumar(conceptosEstimadosHijos, 'cantidadEstimadaAnterior'),
            importeEstimadoAnterior: this.$ObjSumar(conceptosEstimadosHijos, 'importeEstimadoAnterior') || 0,
            cantidadEstimadaAcumulada: this.$ObjSumar(conceptosEstimadosHijos, 'cantidadEstimadaAcumulada') || 0,
            importeEstimadoAcumulado: this.$ObjSumar(conceptosEstimadosHijos, 'importeEstimadoAcumulado'),
            conceptosEstimados: [],
          };
        });

      const partidasNieles = [
        ...partidasNivelCinco,
        ...partidasNivelCuatro,
        ...partidasNivelTres,
        ...partidasNivelDos,
        ...partidasNivelUno,
      ];
      const partidasNielesUnicas = [...new Map(partidasNieles.map((v) => [v.id, v])).values()];

      return [
        ...partidasNielesUnicas,
        ...partidasEstimadas,
      ].sort((a, b) => a.orden - b.orden);
    },
    sumaTotalContratado() {
      const suma = [];
      if (this.getPartidas.length <= 0) return {};

      this.getPartidas.forEach((partida) => {
        const estimado = partida.conceptosEstimados;
        const importes = estimado.map((est) => ({
          importe: est.concepto.importe,
        }));

        suma.push({
          importe: this.$ObjSumar(importes, 'importe'),
        });
      });

      const importe = this.$ObjSumar(suma, 'importe');
      const iva = this.$numberRound((importe * (this.contrato.porcetajeIva)));
      const total = this.$numberRound((importe + iva));

      return {
        importe,
        iva,
        total,
      };
    },
    sumaTotalEstimadoAnteriror() {
      const suma = [];
      if (this.getPartidas.length <= 0) return {};

      this.getPartidas.forEach((partida) => {
        suma.push({
          importe: this.$ObjSumar(partida.conceptosEstimados, 'importeEstimadoAnterior') || 0,
        });
      });

      const importe = this.$ObjSumar(suma, 'importe');
      const iva = this.$numberRound((importe * (this.contrato.porcetajeIva)));
      const total = this.$numberRound((importe + iva));

      return {
        importe,
        iva,
        total,
      };
    },
    sumaTotalEstimadoActual() {
      const suma = [];
      if (this.getPartidas.length <= 0) return {};

      this.getPartidas.forEach((partida) => {
        suma.push({
          importe: this.$ObjSumar(partida.conceptosEstimados, 'importe'),
        });
      });

      const importe = this.$ObjSumar(suma, 'importe');
      const iva = this.$numberRound((importe * (this.contrato.porcetajeIva)));
      const total = this.$numberRound((importe + iva));

      return {
        importe,
        iva,
        total,
      };
    },
    getSupervisorEnRelacionConceptos() {
      if (!this.contrato) return null;
      if (!this.contrato.responsables) return null;
      return this.contrato.responsables.find((responsable) => responsable.principal === true);
    },
    getContratoSupervisionExternaEnRelacionConceptos() {
      return this.contrato.contratosRelacionados
        .find(({ esSupervisionExterna }) => esSupervisionExterna === true);
    },
  },
};
